const MODULE_URL = 'share_roots';

export default {
  MODULE_URL: MODULE_URL,
  ROOTS_URL: MODULE_URL,

  CREATED: 'share_root_created',
  UPDATED: 'share_root_updated',
  REMOVED: 'share_root_removed',

  VIEW_ID: 'share_root',
};
